// DataContext.tsx
import React, { createContext, useContext, useState } from "react";
import { useMutation, gql } from "@apollo/client";

// 1. Define your mutation
const CREATE_LOAD_DISPATCH = gql`
  mutation CreateLoadDispatch($input: LoadDispatchInput!) {
    createLoadDispatch(input: $input) {
      id
      load_id
      trailer
    }
  }
`;

// 2. Extend the context type
interface DataContextType {
  filterData: any;
  setFilterData: (d: any) => void;
  createLoadDispatch: (formValues: any) => Promise<void>;
  loading: boolean;
  error: any;
}

export const DataContext = createContext<DataContextType | undefined>(
  undefined,
);

interface DataProviderProps {
  children: React.ReactNode;
}

export function FilterDataProvider({ children }: DataProviderProps) {
  const [filterData, setFilterData] = useState<any>(null);
  const [isSuccess, setIsSuccess] = useState<any>(null);

  // 3. Use the mutation
  const [mutate, { loading, error }] = useMutation(CREATE_LOAD_DISPATCH);

  // 4. Wrap your mutation in a context function
  const createLoadDispatch = async (formValues: any) => {
    const result = await mutate({
      variables: {
        input: {
          ...formValues,
        },
      },
      context: { clientName: "loadDispatch" },
    });
    setIsSuccess(true);
  };

  return (
    <DataContext.Provider
      value={{ filterData, setFilterData, createLoadDispatch, loading, error }}
    >
      {children}
    </DataContext.Provider>
  );
}

// 5. Hook for consuming the context
export const useFilterData = () => {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be inside DataProvider");
  return ctx;
};
